import { styled } from '@thg-commerce/enterprise-theme'

import { mq, spacing, Text } from '@thg-commerce/gravity-theme'
import { Picture } from '@thg-commerce/gravity-system'

export const Container = styled.div`
  width: 100%;
  max-width: ${(props) =>
    props.theme.widget.imageSelectSlider.layout.fullWidth};
  overflow: hidden;
  margin: 0 auto;
`

export const SlidesWrapper = styled.div<{
  activeSlide: number
}>`
  display: flex;
  transition: transform 0.5s ease;
  transform: ${(props) => `translateX(-${props.activeSlide * 100}%)`};
`

export const SlideItem = styled.div`
  flex: 0 0 100%;
`

export const ThumbnailWrapper = styled.div`
  width: fit-content;
  margin: ${spacing(-3)} auto 0;
  position: relative;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  ${(props) => mq(props.theme.breakpointUtils.map, 'md')} {
    margin: ${spacing(-5)} auto 0;
  }
`

export const ThumbnailItem = styled.img<{
  isActive: boolean
}>`
  width: 54px;
  height: 54px;
  border: 4px solid
    ${(props) =>
      props.isActive
        ? props.theme.colors.palette.greys.darker
        : props.theme.colors.palette.greys.white};
  margin: 0 ${spacing(1)} ${spacing(1.5)};
  cursor: pointer;

  ${(props) => mq(props.theme.breakpointUtils.map, 'md')} {
    width: 88px;
    height: 88px;
    margin: 0 ${spacing(1.5)} ${spacing(2)};
  }

  &:focus {
    outline: 0;
    border-color: ${(props) =>
      props.isActive
        ? props.theme.colors.palette.greys.white
        : props.theme.colors.palette.greys.darker};
  }
`

export const StyledPicture = styled(Picture)`
  width: 100%;
  height: auto;
`

export const StyledTitle = styled.h2`
  ${Text('xlarge1', 'alternate')}
  margin-top: ${spacing(3)};
`

export const StyledText = styled.div`
  ${Text('large2', 'alternate')}
  margin-top: ${spacing(3)};
`
